/**
 * Internationalization (i18n) System
 * Supports French, Dutch, and English
 */

export const translations = {
    // ============================================
    // MARKETING (STATIC PAGES)
    // ============================================
    'nav.home': { fr: 'Accueil', nl: 'Home', en: 'Home' },
    'nav.about': { fr: 'À propos', nl: 'Over ons', en: 'About' },
    'nav.services': { fr: 'Services', nl: 'Diensten', en: 'Services' },
    'nav.gallery': { fr: 'Galerie', nl: 'Galerij', en: 'Gallery' },
    'nav.blog': { fr: 'Blog', nl: 'Blog', en: 'Blog' },
    'nav.contact': { fr: 'Contact', nl: 'Contact', en: 'Contact Us' },
    'nav.get_quote': { fr: 'Obtenir un devis', nl: 'Offerte aanvragen', en: 'Get A Quote' },

    'footer.newsletter_signup': { fr: 'Inscription newsletter', nl: 'Nieuwsbrief', en: 'Newsletter Signup' },
    'footer.newsletter_title': {
        fr: 'Abonnez-vous à notre newsletter',
        nl: 'Abonneer u op onze nieuwsbrief',
        en: 'Subscribe Our Newsletter'
    },
    'footer.enter_email': { fr: 'Entrez votre e-mail', nl: 'Vul uw e-mail in', en: 'Enter Your Email' },
    'footer.subscribe': { fr: 'S’abonner', nl: 'Abonneren', en: 'Subscribe' },
    // Backward-compatible key used in marketing footer HTML
    'footer.newsletter_subscribe': { fr: 'S’abonner', nl: 'Abonneren', en: 'Subscribe' },
    'footer.useful_links': { fr: 'Liens utiles', nl: 'Handige links', en: 'useful links' },
    'footer.contact_us': { fr: 'Contact', nl: 'Contact', en: 'contact us' },
    'footer.call_now': { fr: 'Appelez-nous', nl: 'Bel ons', en: 'Call Now' },

    // ============================================
    // LANDING PAGE
    // ============================================
    'landing.hero.title': {
        fr: 'Obtenez votre devis en 5 minutes',
        nl: 'Krijg uw offerte in 5 minuten',
        en: 'Get your quote in 5 minutes'
    },
    'landing.hero.subtitle': {
        fr: 'Devis gratuit et sans engagement pour vos projets d\'énergie renouvelable',
        nl: 'Gratis en vrijblijvende offerte voor uw hernieuwbare energieprojecten',
        en: 'Free and no-obligation quote for your renewable energy projects'
    },
    'landing.hero.cta': {
        fr: 'Démarrer mon devis',
        nl: 'Start mijn offerte',
        en: 'Start my quote'
    },
    'landing.services.title': {
        fr: 'Nos services',
        nl: 'Onze diensten',
        en: 'Our services'
    },
    'landing.services.subtitle': {
        fr: 'Choisissez le service qui vous intéresse',
        nl: 'Kies de dienst die u interesseert',
        en: 'Choose the service you\'re interested in'
    },
    'landing.how_it_works.title': {
        fr: 'Comment ça marche ?',
        nl: 'Hoe werkt het?',
        en: 'How does it work?'
    },
    'landing.how_it_works.step1.title': {
        fr: 'Choisissez votre service',
        nl: 'Kies uw dienst',
        en: 'Choose your service'
    },
    'landing.how_it_works.step1.desc': {
        fr: 'Sélectionnez le type de projet qui vous intéresse',
        nl: 'Selecteer het type project dat u interesseert',
        en: 'Select the type of project you\'re interested in'
    },
    'landing.how_it_works.step2.title': {
        fr: 'Remplissez le formulaire',
        nl: 'Vul het formulier in',
        en: 'Fill out the form'
    },
    'landing.how_it_works.step2.desc': {
        fr: 'Répondez à quelques questions sur votre projet',
        nl: 'Beantwoord enkele vragen over uw project',
        en: 'Answer a few questions about your project'
    },
    'landing.how_it_works.step3.title': {
        fr: 'Recevez votre estimation',
        nl: 'Ontvang uw schatting',
        en: 'Receive your estimate'
    },
    'landing.how_it_works.step3.desc': {
        fr: 'Obtenez immédiatement une fourchette de prix réaliste',
        nl: 'Krijg onmiddellijk een realistische prijsindicatie',
        en: 'Get an immediate realistic price range'
    },
    'landing.how_it_works.step4.title': {
        fr: 'Nous vous contactons',
        nl: 'Wij contacteren u',
        en: 'We contact you'
    },
    'landing.how_it_works.step4.desc': {
        fr: 'Notre équipe vous recontacte pour finaliser votre devis',
        nl: 'Ons team neemt contact met u op om uw offerte te finaliseren',
        en: 'Our team contacts you to finalize your quote'
    },

    // ============================================
    // QUOTE FORM
    // ============================================
    'quote.title': {
        fr: 'Demande de devis',
        nl: 'Offerteaanvraag',
        en: 'Quote request'
    },
    'quote.step': {
        fr: 'Étape {current} sur {total}',
        nl: 'Stap {current} van {total}',
        en: 'Step {current} of {total}'
    },
    'quote.next': {
        fr: 'Suivant',
        nl: 'Volgende',
        en: 'Next'
    },
    'quote.previous': {
        fr: 'Précédent',
        nl: 'Vorige',
        en: 'Previous'
    },
    'quote.submit': {
        fr: 'Envoyer ma demande',
        nl: 'Verstuur mijn aanvraag',
        en: 'Submit my request'
    },
    'quote.required_field': {
        fr: 'Ce champ est requis',
        nl: 'Dit veld is verplicht',
        en: 'This field is required'
    },
    'quote.upload_photos': {
        fr: 'Télécharger des photos (max 5)',
        nl: 'Upload foto\'s (max 5)',
        en: 'Upload photos (max 5)'
    },
    'quote.additional_notes': {
        fr: 'Informations complémentaires',
        nl: 'Aanvullende informatie',
        en: 'Additional information'
    },
    'quote.additional_notes_placeholder': {
        fr: 'Décrivez votre projet en détail...',
        nl: 'Beschrijf uw project in detail...',
        en: 'Describe your project in detail...'
    },

    // ============================================
    // PRICE DISPLAY
    // ============================================
    'price.estimated_range': {
        fr: 'Estimation: {min}€ - {max}€',
        nl: 'Schatting: {min}€ - {max}€',
        en: 'Estimate: {min}€ - {max}€'
    },
    'price.breakdown': {
        fr: 'Détail du devis',
        nl: 'Offerte details',
        en: 'Quote breakdown'
    },
    'price.base_components': {
        fr: 'Composants de base',
        nl: 'Basiscomponenten',
        en: 'Base components'
    },
    'price.variable_costs': {
        fr: 'Coûts variables',
        nl: 'Variabele kosten',
        en: 'Variable costs'
    },
    'price.selected_equipment': {
        fr: 'Équipement sélectionné',
        nl: 'Geselecteerde apparatuur',
        en: 'Selected equipment'
    },
    'price.options_modifications': {
        fr: 'Options et modifications',
        nl: 'Opties en aanpassingen',
        en: 'Options and modifications'
    },
    'price.total_min': {
        fr: 'Total minimum',
        nl: 'Totaal minimum',
        en: 'Minimum total'
    },
    'price.total_max': {
        fr: 'Total maximum',
        nl: 'Totaal maximum',
        en: 'Maximum total'
    },

    // ============================================
    // BUDGET CHECK
    // ============================================
    'budget.title': {
        fr: 'Vérification du budget',
        nl: 'Budgetcontrole',
        en: 'Budget check'
    },
    'budget.question': {
        fr: 'Quel est votre budget pour ce projet ?',
        nl: 'Wat is uw budget voor dit project?',
        en: 'What is your budget for this project?'
    },
    'budget.fits': {
        fr: 'Parfait ! Votre budget correspond à notre estimation.',
        nl: 'Perfect! Uw budget komt overeen met onze schatting.',
        en: 'Perfect! Your budget matches our estimate.'
    },
    'budget.too_low': {
        fr: 'Attention: Votre budget ({budget}€) est inférieur à notre estimation ({min}€ - {max}€). Souhaitez-vous ajuster vos besoins ou nous contacter pour en discuter ?',
        nl: 'Let op: Uw budget ({budget}€) ligt onder onze schatting ({min}€ - {max}€). Wilt u uw behoeften aanpassen of contact met ons opnemen om dit te bespreken?',
        en: 'Warning: Your budget ({budget}€) is below our estimate ({min}€ - {max}€). Would you like to adjust your requirements or contact us to discuss?'
    },
    'budget.adjust': {
        fr: 'Ajuster mes besoins',
        nl: 'Mijn behoeften aanpassen',
        en: 'Adjust my requirements'
    },
    'budget.continue_anyway': {
        fr: 'Continuer quand même',
        nl: 'Toch doorgaan',
        en: 'Continue anyway'
    },

    // ============================================
    // CONTACT FORM
    // ============================================
    'contact.title': {
        fr: 'Vos coordonnées',
        nl: 'Uw contactgegevens',
        en: 'Your contact information'
    },
    'contact.name': {
        fr: 'Nom complet',
        nl: 'Volledige naam',
        en: 'Full name'
    },
    'contact.email': {
        fr: 'Adresse e-mail',
        nl: 'E-mailadres',
        en: 'Email address'
    },
    'contact.phone': {
        fr: 'Téléphone',
        nl: 'Telefoon',
        en: 'Phone'
    },
    'contact.address': {
        fr: 'Adresse complète',
        nl: 'Volledig adres',
        en: 'Full address'
    },
    'contact.postal_code': {
        fr: 'Code postal',
        nl: 'Postcode',
        en: 'Postal code'
    },
    'contact.city': {
        fr: 'Ville',
        nl: 'Stad',
        en: 'City'
    },

    // ============================================
    // GDPR & PRIVACY
    // ============================================
    'gdpr.consent': {
        fr: 'J\'accepte que mes données soient utilisées pour traiter ma demande de devis',
        nl: 'Ik ga ermee akkoord dat mijn gegevens worden gebruikt om mijn offerteaanvraag te verwerken',
        en: 'I agree that my data may be used to process my quote request'
    },
    'gdpr.marketing': {
        fr: 'Je souhaite recevoir des informations sur vos services',
        nl: 'Ik wil informatie ontvangen over uw diensten',
        en: 'I would like to receive information about your services'
    },
    'gdpr.privacy_policy': {
        fr: 'Politique de confidentialité',
        nl: 'Privacybeleid',
        en: 'Privacy policy'
    },

    // ============================================
    // CONFIRMATION
    // ============================================
    'confirmation.title': {
        fr: 'Demande envoyée !',
        nl: 'Aanvraag verzonden!',
        en: 'Request sent!'
    },
    'confirmation.message': {
        fr: 'Merci pour votre demande. Nous vous contacterons dans les plus brefs délais.',
        nl: 'Bedankt voor uw aanvraag. We nemen zo snel mogelijk contact met u op.',
        en: 'Thank you for your request. We will contact you as soon as possible.'
    },
    'confirmation.reference': {
        fr: 'Référence de votre demande: {ref}',
        nl: 'Referentie van uw aanvraag: {ref}',
        en: 'Your request reference: {ref}'
    },
    'confirmation.next_steps': {
        fr: 'Prochaines étapes',
        nl: 'Volgende stappen',
        en: 'Next steps'
    },
    'confirmation.step1': {
        fr: 'Nous analysons votre demande',
        nl: 'We analyseren uw aanvraag',
        en: 'We analyze your request'
    },
    'confirmation.step2': {
        fr: 'Nous vous contactons sous 24-48h',
        nl: 'We nemen binnen 24-48u contact met u op',
        en: 'We contact you within 24-48h'
    },
    'confirmation.step3': {
        fr: 'Nous finalisons votre devis personnalisé',
        nl: 'We finaliseren uw gepersonaliseerde offerte',
        en: 'We finalize your personalized quote'
    },

    // ============================================
    // DASHBOARD
    // ============================================
    'dashboard.title': {
        fr: 'Tableau de bord',
        nl: 'Dashboard',
        en: 'Dashboard'
    },
    'dashboard.contractor': {
        fr: 'Tableau de bord des devis',
        nl: 'Offerte Dashboard',
        en: 'Quotation Dashboard'
    },
    'dashboard.login.title': {
        fr: 'Connexion au tableau de bord',
        nl: 'Dashboard login',
        en: 'Dashboard Login'
    },
    'dashboard.login.subtitle': {
        fr: 'Entrez le mot de passe pour accéder au tableau de bord',
        nl: 'Voer wachtwoord in om toegang te krijgen tot het dashboard',
        en: 'Enter password to access contractor dashboard'
    },
    'dashboard.login.password': {
        fr: 'Mot de passe',
        nl: 'Wachtwoord',
        en: 'Password'
    },
    'dashboard.login.button': {
        fr: 'Se connecter',
        nl: 'Inloggen',
        en: 'Login'
    },
    'dashboard.login.default': {
        fr: 'Mot de passe par défaut',
        nl: 'Standaard wachtwoord',
        en: 'Default password'
    },
    'dashboard.logout': {
        fr: 'Déconnexion',
        nl: 'Uitloggen',
        en: 'Logout'
    },
    'dashboard.stats.total': {
        fr: 'Total des demandes',
        nl: 'Totaal aanvragen',
        en: 'Total Leads'
    },
    'dashboard.stats.new': {
        fr: 'Nouvelles',
        nl: 'Nieuw',
        en: 'New'
    },
    'dashboard.stats.accepted': {
        fr: 'Acceptées',
        nl: 'Geaccepteerd',
        en: 'Accepted'
    },
    'dashboard.stats.avg_quote': {
        fr: 'Devis moyen',
        nl: 'Gem. offerte',
        en: 'Avg. Quote'
    },
    'dashboard.filter.all': {
        fr: 'Toutes',
        nl: 'Alle',
        en: 'All'
    },
    'dashboard.filter.new': {
        fr: 'Nouvelles',
        nl: 'Nieuw',
        en: 'New'
    },
    'dashboard.filter.contacted': {
        fr: 'Contactées',
        nl: 'Gecontacteerd',
        en: 'Contacted'
    },
    'dashboard.filter.quoted': {
        fr: 'Devis envoyé',
        nl: 'Offerte verstuurd',
        en: 'Quoted'
    },
    'dashboard.filter.accepted': {
        fr: 'Acceptées',
        nl: 'Geaccepteerd',
        en: 'Accepted'
    },
    'dashboard.search.placeholder': {
        fr: '🔍 Rechercher par nom, email ou ID...',
        nl: '🔍 Zoeken op naam, email of ID...',
        en: '🔍 Search by name, email, or ID...'
    },
    'dashboard.table.id': {
        fr: 'ID',
        nl: 'ID',
        en: 'ID'
    },
    'dashboard.table.customer': {
        fr: 'Client',
        nl: 'Klant',
        en: 'Customer'
    },
    'dashboard.table.service': {
        fr: 'Service',
        nl: 'Dienst',
        en: 'Service'
    },
    'dashboard.table.quote': {
        fr: 'Devis',
        nl: 'Offerte',
        en: 'Quote'
    },
    'dashboard.table.score': {
        fr: 'Score',
        nl: 'Score',
        en: 'Score'
    },
    'dashboard.table.status': {
        fr: 'Statut',
        nl: 'Status',
        en: 'Status'
    },
    'dashboard.table.date': {
        fr: 'Date',
        nl: 'Datum',
        en: 'Date'
    },
    'dashboard.table.actions': {
        fr: 'Actions',
        nl: 'Acties',
        en: 'Actions'
    },
    'dashboard.table.view': {
        fr: 'Voir',
        nl: 'Bekijken',
        en: 'View'
    },
    'dashboard.table.no_leads': {
        fr: 'Aucune demande trouvée',
        nl: 'Geen aanvragen gevonden',
        en: 'No leads found'
    },
    'dashboard.table.loading': {
        fr: 'Chargement des demandes...',
        nl: 'Aanvragen laden...',
        en: 'Loading leads...'
    },
    'dashboard.detail.title': {
        fr: 'Détails de la demande',
        nl: 'Aanvraag details',
        en: 'Lead Details'
    },
    'dashboard.detail.status': {
        fr: 'Statut',
        nl: 'Status',
        en: 'Status'
    },
    'dashboard.detail.customer_info': {
        fr: 'Informations client',
        nl: 'Klantinformatie',
        en: 'Customer Information'
    },
    'dashboard.detail.address': {
        fr: 'Adresse',
        nl: 'Adres',
        en: 'Address'
    },
    'dashboard.detail.quote_info': {
        fr: 'Informations devis',
        nl: 'Offerte informatie',
        en: 'Quote Information'
    },
    'dashboard.detail.project_details': {
        fr: 'Détails du projet',
        nl: 'Project details',
        en: 'Project Details'
    },
    'dashboard.detail.photos': {
        fr: 'Photos',
        nl: 'Foto\'s',
        en: 'Photos'
    },
    'dashboard.detail.notes': {
        fr: 'Notes supplémentaires',
        nl: 'Aanvullende opmerkingen',
        en: 'Additional Notes'
    },
    'dashboard.detail.name': {
        fr: 'Nom',
        nl: 'Naam',
        en: 'Name'
    },
    'dashboard.detail.email': {
        fr: 'Email',
        nl: 'Email',
        en: 'Email'
    },
    'dashboard.detail.phone': {
        fr: 'Téléphone',
        nl: 'Telefoon',
        en: 'Phone'
    },
    'dashboard.detail.language': {
        fr: 'Langue',
        nl: 'Taal',
        en: 'Language'
    },
    'dashboard.detail.service': {
        fr: 'Service',
        nl: 'Dienst',
        en: 'Service'
    },
    'dashboard.detail.estimate': {
        fr: 'Estimation',
        nl: 'Schatting',
        en: 'Estimate'
    },
    'dashboard.detail.qualification': {
        fr: 'Score de qualification',
        nl: 'Kwalificatie score',
        en: 'Qualification Score'
    },
    'dashboard.detail.created': {
        fr: 'Créé le',
        nl: 'Aangemaakt op',
        en: 'Created'
    },
    'dashboard.status.new': {
        fr: 'Nouvelle',
        nl: 'Nieuw',
        en: 'New'
    },
    'dashboard.status.contacted': {
        fr: 'Contactée',
        nl: 'Gecontacteerd',
        en: 'Contacted'
    },
    'dashboard.status.quoted': {
        fr: 'Devis envoyé',
        nl: 'Offerte verstuurd',
        en: 'Quoted'
    },
    'dashboard.status.accepted': {
        fr: 'Acceptée',
        nl: 'Geaccepteerd',
        en: 'Accepted'
    },
    'dashboard.status.rejected': {
        fr: 'Refusée',
        nl: 'Geweigerd',
        en: 'Rejected'
    },
    'dashboard.status_updated': {
        fr: 'Statut mis à jour avec succès',
        nl: 'Status succesvol bijgewerkt',
        en: 'Status updated successfully'
    },
    'dashboard.status_update_failed': {
        fr: 'Échec de la mise à jour du statut',
        nl: 'Status bijwerken mislukt',
        en: 'Failed to update status'
    },
    'dashboard.load_failed': {
        fr: 'Échec du chargement des demandes',
        nl: 'Aanvragen laden mislukt',
        en: 'Failed to load leads'
    },
    'dashboard.lead_load_failed': {
        fr: 'Échec du chargement des détails',
        nl: 'Details laden mislukt',
        en: 'Failed to load lead details'
    },
    'dashboard.invalid_password': {
        fr: 'Mot de passe invalide',
        nl: 'Ongeldig wachtwoord',
        en: 'Invalid password'
    },

    // ============================================
    // COMMON
    // ============================================
    'common.yes': {
        fr: 'Oui',
        nl: 'Ja',
        en: 'Yes'
    },
    'common.no': {
        fr: 'Non',
        nl: 'Nee',
        en: 'No'
    },
    'common.loading': {
        fr: 'Chargement...',
        nl: 'Laden...',
        en: 'Loading...'
    },
    'common.error': {
        fr: 'Une erreur est survenue',
        nl: 'Er is een fout opgetreden',
        en: 'An error occurred'
    },
    'common.close': {
        fr: 'Fermer',
        nl: 'Sluiten',
        en: 'Close'
    },
    'common.save': {
        fr: 'Enregistrer',
        nl: 'Opslaan',
        en: 'Save'
    },
    'common.cancel': {
        fr: 'Annuler',
        nl: 'Annuleren',
        en: 'Cancel'
    },
    'common.back': {
        fr: 'Retour',
        nl: 'Terug',
        en: 'Back'
    },
    'common.home': {
        fr: 'Accueil',
        nl: 'Home',
        en: 'Home'
    },
    'common.select': {
        fr: 'Sélectionner',
        nl: 'Selecteren',
        en: 'Select'
    }
};

// ============================================
// MARKETING AUTO TRANSLATIONS (exact string map)
//
// Marketing pages are static HTML; tagging every node with data-i18n would be
// too invasive. This map + the text-node walker translates all remaining copy.
// ============================================
const MARKETING_TEXT_MAP = {
    // Core nav/page labels
    'Home': { fr: 'Accueil', nl: 'Home', en: 'Home' },
    'About': { fr: 'À propos', nl: 'Over', en: 'About' },
    'about us': { fr: 'à propos', nl: 'over ons', en: 'about us' },
    'Services': { fr: 'Services', nl: 'Diensten', en: 'Services' },
    'Service': { fr: 'Service', nl: 'Dienst', en: 'Service' },
    'Gallery': { fr: 'Galerie', nl: 'Galerij', en: 'Gallery' },
    'Blog': { fr: 'Blog', nl: 'Blog', en: 'Blog' },
    'Blogs': { fr: 'Blog', nl: 'Blogs', en: 'Blogs' },
    'Blogs Single': { fr: 'Article', nl: 'Blogartikel', en: 'Blogs Single' },
    'Blog post': { fr: 'Article', nl: 'Blogbericht', en: 'Blog post' },
    'Contact': { fr: 'Contact', nl: 'Contact', en: 'Contact' },
    'Contact Us': { fr: 'Contactez-nous', nl: 'Contacteer ons', en: 'Contact Us' },
    'contact us': { fr: 'contactez-nous', nl: 'contacteer ons', en: 'contact us' },
    'Get A Quote': { fr: 'Obtenir un devis', nl: 'Offerte aanvragen', en: 'Get A Quote' },
    'Book Now': { fr: 'Réserver', nl: 'Boek nu', en: 'Book Now' },

    // Breadcrumb fragments
    '/ About': { fr: '/ À propos', nl: '/ Over', en: '/ About' },
    '/ Gallery': { fr: '/ Galerie', nl: '/ Galerij', en: '/ Gallery' },
    '/ Blogs': { fr: '/ Blog', nl: '/ Blogs', en: '/ Blogs' },
    '/ Blogs Single': { fr: '/ Article', nl: '/ Blogartikel', en: '/ Blogs Single' },
    '/ Contact Us': { fr: '/ Contact', nl: '/ Contact', en: '/ Contact Us' },
    '/ Services': { fr: '/ Services', nl: '/ Diensten', en: '/ Services' },

    // Newsletter/footer form bits
    'Newsletter Signup': { fr: 'Inscription newsletter', nl: 'Nieuwsbrief inschrijven', en: 'Newsletter Signup' },
    'Subscribe': { fr: "S'abonner", nl: 'Abonneren', en: 'Subscribe' },
    'Subscribe Our Newsletter': { fr: 'Abonnez-vous à notre newsletter', nl: 'Abonneer op onze nieuwsbrief', en: 'Subscribe Our Newsletter' },
    'Enter Your Email': { fr: 'Entrez votre e-mail', nl: 'Vul uw e-mail in', en: 'Enter Your Email' },
    'Call Now': { fr: 'Appeler', nl: 'Bel nu', en: 'Call Now' },
    'Send Now': { fr: 'Envoyer', nl: 'Versturen', en: 'Send Now' },
    'Send Message': { fr: 'Envoyer le message', nl: 'Bericht verzenden', en: 'Send Message' },
    'useful links': { fr: 'liens utiles', nl: 'nuttige links', en: 'useful links' },
    'get a quotes': { fr: 'obtenir un devis', nl: 'offerte aanvragen', en: 'get a quotes' },
    'get in touch': { fr: 'nous contacter', nl: 'neem contact op', en: 'get in touch' },

    // Home hero/services copy
    'experience the power of the sun at its finest': { fr: 'vivez la puissance du soleil à son meilleur', nl: 'ervaar de kracht van de zon op haar best', en: 'experience the power of the sun at its finest' },
    'We design and install high-yield solar panels, efficient heat pumps, smart ventilation, and battery-ready systems tailored for modern Belgian homes.': {
        fr: "Nous concevons et installons des panneaux solaires à haut rendement, des pompes à chaleur efficaces, une ventilation intelligente et des systèmes compatibles batterie, adaptés aux maisons belges modernes.",
        nl: 'Wij ontwerpen en installeren hoogrendement zonnepanelen, efficiënte warmtepompen, slimme ventilatie en batterij-ready systemen, op maat van moderne Belgische woningen.',
        en: 'We design and install high-yield solar panels, efficient heat pumps, smart ventilation, and battery-ready systems tailored for modern Belgian homes.'
    },
    'Our Services': { fr: 'Nos services', nl: 'Onze diensten', en: 'Our Services' },
    'Solar Plans & Services': { fr: 'Plans & services solaires', nl: 'Zonne-energie plannen & diensten', en: 'Solar Plans & Services' },

    // Services list (names + short descriptions)
    'Solar Panels + Battery': { fr: 'Panneaux solaires + batterie', nl: 'Zonnepanelen + batterij', en: 'Solar Panels + Battery' },
    'Solar Panels': { fr: 'Panneaux solaires', nl: 'Zonnepanelen', en: 'Solar Panels' },
    'Solar panel installation with Huawei inverter and optional battery storage.': {
        fr: 'Installation de panneaux solaires avec onduleur Huawei et stockage batterie en option.',
        nl: 'Installatie van zonnepanelen met Huawei-omvormer en optionele batterijopslag.',
        en: 'Solar panel installation with Huawei inverter and optional battery storage.'
    },
    'Air/Water Heat Pump': { fr: 'Pompe à chaleur air/eau', nl: 'Lucht/water warmtepomp', en: 'Air/Water Heat Pump' },
    'Complete R-AQUA R290 heat pump installation with indoor and outdoor monoblock.': {
        fr: 'Installation complète de pompe à chaleur R-AQUA R290 avec monobloc intérieur et extérieur.',
        nl: 'Complete installatie van R-AQUA R290 warmtepomp met binnen- en buitenmonoblock.',
        en: 'Complete R-AQUA R290 heat pump installation with indoor and outdoor monoblock.'
    },
    'Air/Air Heat Pump': { fr: 'Pompe à chaleur air/air', nl: 'Lucht/lucht warmtepomp', en: 'Air/Air Heat Pump' },
    'Reversible air conditioning with indoor and outdoor units for efficient heating and cooling.': {
        fr: 'Climatisation réversible avec unités intérieure et extérieure pour un chauffage et un refroidissement efficaces.',
        nl: 'Omkeerbare airco met binnen- en buitenunit voor efficiënt verwarmen en koelen.',
        en: 'Reversible air conditioning with indoor and outdoor units for efficient heating and cooling.'
    },
    'VMC Ventilation': { fr: 'Ventilation VMC', nl: 'Ventilatie (VMC)', en: 'VMC Ventilation' },
    'DUCO single or double flow ventilation systems with balanced, healthy indoor air.': {
        fr: 'Systèmes de ventilation DUCO simple ou double flux pour un air intérieur sain et équilibré.',
        nl: 'DUCO enkel- of dubbelstroom ventilatiesystemen voor gebalanceerde, gezonde binnenlucht.',
        en: 'DUCO single or double flow ventilation systems with balanced, healthy indoor air.'
    },
    'EV Charging Station': { fr: 'Borne de recharge VE', nl: 'EV-laadpaal', en: 'EV Charging Station' },
    'Smappee charging station installation 7.1kW or 22kW with or without tethered cable.': {
        fr: 'Installation de borne de recharge Smappee 7,1 kW ou 22 kW avec ou sans câble attaché.',
        nl: 'Installatie van Smappee laadpaal 7,1 kW of 22 kW met of zonder vaste kabel.',
        en: 'Smappee charging station installation 7.1kW or 22kW with or without tethered cable.'
    },
    'Interior Insulation': { fr: 'Isolation intérieure', nl: 'Binnenisolatie', en: 'Interior Insulation' },
    'Gyproc + PIR interior insulation with full finishing and painting for energy efficiency.': {
        fr: 'Isolation intérieure Gyproc + PIR avec finitions complètes et peinture pour une meilleure efficacité énergétique.',
        nl: 'Gyproc + PIR binnenisolatie met volledige afwerking en schilderwerk voor energie-efficiëntie.',
        en: 'Gyproc + PIR interior insulation with full finishing and painting for energy efficiency.'
    },
    'Thermodynamic Water Heater': { fr: 'Boiler thermodynamique', nl: 'Thermodynamische boiler', en: 'Thermodynamic Water Heater' },
    'R-AQUA thermodynamic boiler for efficient domestic hot water with heat recovery.': {
        fr: 'Boiler thermodynamique R-AQUA pour une eau chaude sanitaire efficace avec récupération de chaleur.',
        nl: 'R-AQUA thermodynamische boiler voor efficiënt sanitair warm water met warmteterugwinning.',
        en: 'R-AQUA thermodynamic boiler for efficient domestic hot water with heat recovery.'
    },

    // About + contact page longer copy
    'Years of renewable expertise': { fr: "Des années d'expertise en renouvelable", nl: 'Jarenlange expertise in hernieuwbare energie', en: 'Years of renewable expertise' },
    'We obsess over quality and speed: premium components, tidy wiring and ducting, tested airflow and hydraulics, thorough commissioning, and fast, predictable installation timelines. You get a dependable system, transparent pricing, and a partner who treats your home like our own.': {
        fr: "Nous sommes obsédés par la qualité et la rapidité : composants premium, câblage et gaines soignés, débits d'air et hydraulique testés, mise en service complète et délais d'installation rapides et prévisibles. Vous obtenez un système fiable, des prix transparents et un partenaire qui traite votre maison comme la sienne.",
        nl: 'Wij zijn gefocust op kwaliteit en snelheid: premium componenten, nette bekabeling en leidingen, geteste luchtdebieten en hydraulica, grondige inbedrijfstelling en snelle, voorspelbare installatietermijnen. U krijgt een betrouwbaar systeem, transparante prijzen en een partner die uw woning behandelt alsof het de onze is.',
        en: 'We obsess over quality and speed: premium components, tidy wiring and ducting, tested airflow and hydraulics, thorough commissioning, and fast, predictable installation timelines. You get a dependable system, transparent pricing, and a partner who treats your home like our own.'
    },
    'We help Belgian homes switch to renewable energy: solar panels + battery, heat pumps, ventilation, insulation, EV charging, and hot water.': {
        fr: "Nous aidons les foyers belges à passer aux énergies renouvelables : panneaux solaires + batterie, pompes à chaleur, ventilation, isolation, recharge VE et eau chaude.",
        nl: 'Wij helpen Belgische woningen overstappen naar hernieuwbare energie: zonnepanelen + batterij, warmtepompen, ventilatie, isolatie, EV-laden en warm water.',
        en: 'We help Belgian homes switch to renewable energy: solar panels + battery, heat pumps, ventilation, insulation, EV charging, and hot water.'
    },

    // Blog UI/category taxonomy
    'Follow Us': { fr: 'Suivez-nous', nl: 'Volg ons', en: 'Follow Us' },
    'New Categories': { fr: 'Catégories', nl: 'Categorieën', en: 'New Categories' },
    'Tags': { fr: 'Tags', nl: 'Tags', en: 'Tags' },
    'Search Here': { fr: 'Rechercher', nl: 'Zoeken', en: 'Search Here' },
    'Share': { fr: 'Partager', nl: 'Delen', en: 'Share' },
    'Like': { fr: 'J’aime', nl: 'Vind ik leuk', en: 'Like' },
    'Reply': { fr: 'Répondre', nl: 'Antwoorden', en: 'Reply' },
    'Leave A Reply': { fr: 'Laisser une réponse', nl: 'Laat een reactie achter', en: 'Leave A Reply' },
    'Post Comments': { fr: 'Commentaires', nl: 'Reacties', en: 'Post Comments' },
    '0 Comments': { fr: '0 commentaire', nl: '0 reacties', en: '0 Comments' },
    'Views 457': { fr: 'Vues 457', nl: 'Weergaven 457', en: 'Views 457' },
    'Solar Energy': { fr: 'Énergie solaire', nl: 'Zonne-energie', en: 'Solar Energy' },
    'Solar Panel': { fr: 'Panneau solaire', nl: 'Zonnepaneel', en: 'Solar Panel' },
    'Green Energy': { fr: 'Énergie verte', nl: 'Groene energie', en: 'Green Energy' },
    'Power': { fr: 'Énergie', nl: 'Energie', en: 'Power' },
    'Wind': { fr: 'Vent', nl: 'Wind', en: 'Wind' },
    'Heating': { fr: 'Chauffage', nl: 'Verwarming', en: 'Heating' },
    'Heat Pump': { fr: 'Pompe à chaleur', nl: 'Warmtepomp', en: 'Heat Pump' },
    'Geothermal Energy': { fr: 'Énergie géothermique', nl: 'Geothermische energie', en: 'Geothermal Energy' },
    'Passive Houses': { fr: 'Maisons passives', nl: 'Passiefhuizen', en: 'Passive Houses' },
    'Sustainable Construction': { fr: 'Construction durable', nl: 'Duurzaam bouwen', en: 'Sustainable Construction' },
    'Ecosystem': { fr: 'Écosystème', nl: 'Ecosysteem', en: 'Ecosystem' },
    'Sun Rays': { fr: 'Rayons du soleil', nl: 'Zonnestralen', en: 'Sun Rays' },

    // Months
    'March': { fr: 'Mars', nl: 'Maart', en: 'March' },
    'June': { fr: 'Juin', nl: 'Juni', en: 'June' },
    'July': { fr: 'Juillet', nl: 'Juli', en: 'July' },
    'August': { fr: 'Août', nl: 'Augustus', en: 'August' },

    // Common CTAs
    'Read More': { fr: 'En savoir plus', nl: 'Lees meer', en: 'Read More' },
    'read more': { fr: 'en savoir plus', nl: 'lees meer', en: 'read more' },
    'Load More': { fr: 'Charger plus', nl: 'Meer laden', en: 'Load More' },

    // Template filler (so *everything* switches language)
    'It is a long established fact that a reader will be distracted': {
        fr: "Il est bien connu qu'un lecteur sera distrait",
        nl: 'Het is algemeen bekend dat een lezer wordt afgeleid',
        en: 'It is a long established fact that a reader will be distracted'
    },
    'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.': {
        fr: "Il est bien connu qu'un lecteur sera distrait par le contenu lisible d'une page lorsqu'il regarde sa mise en page.",
        nl: 'Het is algemeen bekend dat een lezer wordt afgeleid door leesbare inhoud bij het bekijken van de lay-out van een pagina.',
        en: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.'
    }
};

function normalizeTextKey(text) {
    return String(text).replace(/\s+/g, ' ').trim();
}

function translateMarketingText(text, lang) {
    const key = normalizeTextKey(text);
    if (!key) return null;
    const entry = MARKETING_TEXT_MAP[key];
    if (!entry) return null;
    return entry[lang] || entry.en || key;
}

/**
 * Get translation for a key
 * @param {string} key - Translation key
 * @param {string} lang - Language code (fr, nl, en)
 * @param {Object} params - Parameters to replace in translation
 * @returns {string} Translated text
 */
export function t(key, lang = 'fr', params = {}) {
    const translation = translations[key];

    if (!translation) {
        console.warn(`Translation missing for key: ${key}`);
        return key;
    }

    let text = translation[lang] || translation['en'] || key;

    // Replace parameters
    for (const [param, value] of Object.entries(params)) {
        text = text.replace(new RegExp(`\\{${param}\\}`, 'g'), value);
    }

    return text;
}

/**
 * Get current language from URL or localStorage
 */
export function getCurrentLanguage() {
    const urlParams = new URLSearchParams(window.location.search);
    const urlLang = urlParams.get('lang');

    if (urlLang && ['fr', 'nl', 'en'].includes(urlLang)) {
        localStorage.setItem('preferred_language', urlLang);
        return urlLang;
    }

    const storedLang = localStorage.getItem('preferred_language');
    if (storedLang && ['fr', 'nl', 'en'].includes(storedLang)) {
        return storedLang;
    }

    // Default to French
    return 'fr';
}

/**
 * Set current language
 */
export function setLanguage(lang) {
    if (!['fr', 'nl', 'en'].includes(lang)) {
        console.error(`Invalid language: ${lang}`);
        return;
    }

    localStorage.setItem('preferred_language', lang);

    // Update URL
    const url = new URL(window.location);
    url.searchParams.set('lang', lang);
    window.history.pushState({}, '', url);

    // Trigger language change event
    window.dispatchEvent(new CustomEvent('languagechange', { detail: { language: lang } }));
}

/**
 * Apply translations to DOM elements.
 * - data-i18n: replaces textContent
 * - data-i18n-placeholder: replaces placeholder
 */
export function applyTranslations(root = document) {
    const lang = getCurrentLanguage();
    const scope = root?.querySelectorAll ? root : document;

    scope.querySelectorAll('[data-i18n]').forEach((el) => {
        const key = el.getAttribute('data-i18n');
        if (!key) return;
        el.textContent = t(key, lang);
    });

    scope.querySelectorAll('[data-i18n-placeholder]').forEach((el) => {
        const key = el.getAttribute('data-i18n-placeholder');
        if (!key) return;
        el.setAttribute('placeholder', t(key, lang));
    });

    // Auto-translate remaining static marketing text nodes (exact string match).
    const rootNode = scope instanceof Document ? scope.body : scope;
    if (rootNode && typeof document !== 'undefined' && document.createTreeWalker) {
        const walker = document.createTreeWalker(rootNode, NodeFilter.SHOW_TEXT);
        while (walker.nextNode()) {
            const node = walker.currentNode;
            const parent = node.parentElement;
            if (!parent) continue;
            const tag = parent.tagName;
            if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT') continue;
            if (parent.closest('[data-i18n],[data-i18n-skip]')) continue;

            const raw = node.nodeValue;
            if (!raw || !raw.trim()) continue;

            const translated = translateMarketingText(raw, lang);
            if (!translated) continue;

            const match = raw.match(/^(\s*)([\s\S]*?)(\s*)$/);
            if (!match) continue;
            const [, lead, , trail] = match;
            node.nodeValue = `${lead}${translated}${trail}`;
        }
    }

    // Auto-translate common attributes if present.
    scope.querySelectorAll('input[placeholder], textarea[placeholder]').forEach((el) => {
        if (el.hasAttribute('data-i18n-placeholder') || el.closest('[data-i18n-skip]')) return;
        const placeholder = el.getAttribute('placeholder');
        const translated = placeholder ? translateMarketingText(placeholder, lang) : null;
        if (translated) el.setAttribute('placeholder', translated);
    });

    scope.querySelectorAll('input[value], button[value]').forEach((el) => {
        if (el.hasAttribute('data-i18n') || el.closest('[data-i18n-skip]')) return;
        const value = el.getAttribute('value');
        const translated = value ? translateMarketingText(value, lang) : null;
        if (translated) el.setAttribute('value', translated);
    });

    // Document title (if it matches an entry).
    if (scope instanceof Document && scope.title) {
        const translatedTitle = translateMarketingText(scope.title, lang);
        if (translatedTitle) scope.title = translatedTitle;
    }
}

export default { t, getCurrentLanguage, setLanguage, applyTranslations, translations };
